import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { columns } from "../../../internals/data/gridData"; // Keep columns if needed
import { Client, DataGridTypes } from "../../../utils/types";
import { useDashboardPage } from '../../../context/DashboardPageContext';
import { useQuery } from '@tanstack/react-query';
import { fetchClients } from '../../../utils/helper';

import { useAuth } from "../../../context/AuthContext";


export type CustomizedDataGridProps = {
  page: DataGridTypes;
  filter: string;
  setSelectedClient: (client: Client | undefined) => void;
  selectedClient?: Client | undefined;
};

export default function CustomizedDataGrid(props: CustomizedDataGridProps) {
  const { page, filter, setSelectedClient, selectedClient } = props;

  const { jwt } = useAuth();

  const { setTransferedClient, transferedClient, setPage } = useDashboardPage();

  // Fetch clients from React Query cache
  const { data: clients = [] } = useQuery({
    queryKey: ['clients'],
    queryFn: () => fetchClients(jwt),
  });

  const redirectToClientPage = (client: Client) => {
    setTransferedClient(client);
    setPage('clients');
  };
  
  let filteredResults: Client[] = [];

  if (filter !== "All") {
    filteredResults = clients.filter((client) => client.type === filter);
  }

  useEffect(() => {
    if (!selectedClient && transferedClient === undefined && clients.length > 0) {
      setSelectedClient(clients[0]);
    }
    if (transferedClient) {
      setSelectedClient(transferedClient);
    }
  }, [clients, selectedClient, transferedClient, setSelectedClient]);

  return (
    <DataGrid
      rows={filteredResults.length ? filteredResults : clients}
      columns={columns}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
      }
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
      }}
      pageSizeOptions={[10, 20, 50]}
      disableColumnResize
      density="compact"
      onRowClick={page === DataGridTypes.DASHBOARD ? (params) => redirectToClientPage(params.row) : (params) => setSelectedClient(params.row)}
      slotProps={{
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: "outlined",
              size: "small",
            },
            columnInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            operatorInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: "outlined",
                size: "small",
              },
            },
          },
        },
      }}
    />
  );
}
